var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.186 31.814l10.627 10.627L46.44 31.814M35.813 38.568V12.703",
    stroke: "#1B264F",
    strokeWidth: 5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.104 41.717v14.62a2.024 2.024 0 01-2.025 2.023H13.546a2.025 2.025 0 01-2.024-2.024v-14.62",
    stroke: "#1B264F",
    strokeWidth: 5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/images/MAUploadIcon-1f25f718.svg";
export { SvgMaUploadIcon as ReactComponent };